<script>
   /*************************************************************/
   /* Svelte component for calculation of global model          */
   /*************************************************************/

   import { cbind } from 'mdatools/arrays';
   import { splitregdata } from 'mdatools/models';

   import { Container, ButtonCancel, Button, Range, Spinner } from './controls';
   import { pcvpls, pls_predict } from './wasm/pcvpls.js';
   import PCV from './wasm/pcv_wasm.js';

   // main properties of the whole app
   export let dataset = null;
   export let model = null;
   export let pvset = null;
   export let pvres = null;
   export let calres = null;
   export let scalars = null;
   export let pvoptions;

   // error handling parameetrs
   let status = 'neutral';
   let errMsg = null;

   let ncomp = pvoptions.ncompRec;
   let promise;

   // function for downloading of PV-set
   function downloadPVSet(e) {
      const out = cbind(dataset.values.getcolumn(1), pvset);
      const blob = new Blob([out.toCSV(dataset.sep, dataset.dec, dataset.header, dataset.labels)], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', 'pvset.csv');
      a.click()
   }

   // function that computes PV-set using given parameters
   async function computePVSet(data, model) {
      promise = PCV()
         .then(Module => {
            const [X, Y] = splitregdata(data);
            const [a, b] = pcvpls(Module, model, X, Y, ncomp, pvoptions.nseg, pvoptions.type, 0);
            pvset = a;
            scalars = b;
            pvoptions.ncompSel = ncomp;
            pvres = pls_predict(Module, model, pvset, Y, ncomp);
            calres = pls_predict(Module, model, X, Y, ncomp);
         })
         .catch((e) => {
            pvset = null;
            pvres = null;
            status = 'error';
            errMsg = e;
         });
   }

   // event handler which triggers the model computation
   function compute(e) {
      status = 'neutral';
      errMsg = null;
      computePVSet(dataset.values, model);
   }

   // function which resets the state of the component
   function reset() {
      status = 'neutral';
      pvoptions.ncompSel = pvoptions.ncompRec;
      ncomp = pvoptions.ncompRec;
      errMsg = null;
      promise = null;
      pvset = null;
      pvres = null;
      calres = null;
      scalars = null;
   }

   // if data file is empty reset status and error messages
   $: if (model === null) reset();

   // update selected number of components in object with PV options
   $: pvoptions.ncompSel = ncomp;
</script>

<div class:warning={pvoptions.ncompSel > pvoptions.ncompRec}>

{#if (model && !pvset) && status !== 'busy'}
   <Container label="# of LVs">
      <Range id="ncomp" bind:value={ncomp} min={1} max={model.ncomp} step={1} decNum={0} />
   </Container>
   <Container label=' '>
      <Button on:click={compute}>Compute PV-set</Button>
   </Container>
{/if}

{#if promise}

   {#await promise}
      <Container>
         <Spinner />
         <p>Computing PV-set...</p>
      </Container>
   {:then value}
      {#if pvset !== null}
      <Container>
         <p>Final PV-set is computed with {ncomp} LVs.</p>
         <ButtonCancel on:click={reset} />
      </Container>
      <Container label=' '>
         <Button on:click={downloadPVSet}>Download</Button>
      </Container>
      {/if}

   {:catch error}
      <Container status='error'>
         <p>{error}</p>
      </Container>
   {/await}

{/if}

{#if status === 'error' && errMsg}
   <Container status='error'>
      <p>{errMsg}</p>
   </Container>
{/if}
</div>

<style>
   .warning :global(.range-slider){
      background-color: #ff3322;
      border-right-color: #a02211;
   }
</style>